import { AnalyticsStore } from 'bernie-plugin-mobx';
import { codeSplit, Controller, FetchOptions, FetchPageOptions, Result } from 'bernie-core';
import { PageData, AlternateHrefLangLink } from 'bernie-http';
import { Localization } from 'bernie-l10n';
import '../client/temp-common-imports';
import analyticsUtil from '../util/analytics-util';
import { supportedLocales } from '../config/supported-locales';

import { pageNames } from '../data/page-names';

export class HomeController implements Controller {
  public pageId = pageNames.home;
  public path = '/:localeName/home';
  public routeName = 'home';
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "home-page" */ '../views/home-page'));
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    const stores = options.stores;
    const { request } = options;
    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');

    const context = request.context;

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, context);

    return Promise.resolve({});
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(options: FetchPageOptions): Promise<PageData> {
    const localization = new Localization(options.context.locale);

    const pageData = {
      title: localization.formatText('home.page.title'),
      seo: {
        canonical: `https://affiliates.expediagroup.com/${options.params.localeName}/home`,
        additionalMeta: supportedLocales.map(
          (lang) =>
            new AlternateHrefLangLink(lang.langCode, `https://affiliates.expediagroup.com/${lang.langCode}/home`),
        ),
        description: localization.formatText('home.page.description'),
        robots: '',
      },
    };

    return Promise.resolve(pageData) as Promise<PageData>;
  }
}
